import React from "react"
import { Button, Flex, Select, Text } from "@capioweb/ui-components/src"
import { useState } from "react"
import {
	BooleanProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { LocalesContext } from "../../context"
import { sendFastlistingLayerPush } from "../../utils"
import { XhtmlString } from "../../@types/CapioWeb/core"
import { createMarkup, Rte } from "@capioweb/ui-components/src"

interface CapioEnlistLinkBlockProps {
	header: StringProperty
	preamble: StringProperty
	infoText: XhtmlString
	items: UnitProps[]
	regions: OptionProps[]
	marginBottom?: BooleanProperty
}
interface UnitProps {
	value: string
	name: string
	regionId: string
	registrationLink: string
}
interface RegionProps {
	value: string
	label: string
}

interface OptionProps extends UnitProps {
	label: string
	value: string
}

const CapioEnlistLinkBlock: React.FC<CapioEnlistLinkBlockProps> = (props) => {
	const [selectedRegion, setSelectedRegion] = useState<RegionProps>(null)

	const [selectedUnit, setSelectedUnit] = useState<UnitProps>(null)

	const [activeUnits, setActiveUnits] = React.useState<OptionProps[]>([])

	const { translate, translationKeys } = React.useContext(LocalesContext)

	React.useEffect(() => {
		if (!selectedRegion) return

		const newActiveUnits = props.items.reduce((acc, unit) => {
			return [
				...acc,
				...(unit.regionId === selectedRegion.value && [
					{
						value: unit.name,
						label: unit.name,
						registrationLink: unit.registrationLink,
						regionId: unit.regionId,
					},
				]),
			]
		}, [])
		setSelectedUnit(null)
		setActiveUnits(newActiveUnits)
	}, [selectedRegion])

	return (
		<Flex
			w={1}
			backgroundColor="blue33"
			justifyContent="center"
			mb={props.marginBottom?.value ? 3 : 0}
		>
			<Flex
				flexDirection="column"
				justifyContent="center"
				maxw={69}
				px={3}
				py={6.5}
				m="0 auto"
			>
				<Text variant="headline-2" textAlign="center">
					{props.header?.value}
				</Text>
				<Text variant="preamble" textAlign="center">
					{props.preamble?.value}
				</Text>
				<Select
					options={props.regions}
					placeholder={
						!selectedRegion && translate(translationKeys.selectRegion)
					}
					aria-label={translate(translationKeys.selectRegion)}
					onChange={(event) => {
						setSelectedRegion(
							props.regions.find(
								(region) =>
									region.value.toString() === event.currentTarget.value
							)
						)
					}}
				/>
				<Select
					onChange={(event) =>
						setSelectedUnit(
							activeUnits.find(
								(unit) => unit.value === event.currentTarget.value
							)
						)
					}
					placeholder={translate(translationKeys.selectUnit)}
					options={activeUnits}
					disabled={!selectedRegion}
					aria-label={translate(translationKeys.selectUnit)}
				/>
				<Flex maxw={57} m="auto" px={3}>
					{props.infoText?.value && (
						<Text as="div" variant="paragraph-16" textAlign="center">
							<Rte>
								<div
									dangerouslySetInnerHTML={{ __html: props.infoText.value }}
								/>
							</Rte>
						</Text>
					)}
				</Flex>
				<Flex
					m="auto"
					mt={4.5}
					w={{ _: "100%", m: "fit-content" }}
					flexDirection={{ _: "column", m: "row" }}
				>
					{selectedUnit ? (
						<Button.Anchor
							href={selectedUnit.registrationLink}
							onClick={() => {
								sendFastlistingLayerPush(
									selectedRegion.label,
									selectedUnit.value
								)
							}}
						>
							{translate(translationKeys.nextStep)}
						</Button.Anchor>
					) : (
						<Button disabled>{translate(translationKeys.nextStep)}</Button>
					)}
				</Flex>
			</Flex>
		</Flex>
	)
}

export { CapioEnlistLinkBlock }
